import { DexResultsSummaryView } from '@mark43/dex-api';
import { Text } from '@cad-arc';
import { DexResultMenuListItem } from './dex-result-item';
import { DexResultItemTrailingVisual } from './dex-result-item-trailing-visual';
import { UnreadIndicator } from './unread-indicator';

export function ResultsSummaryItem({
    isSelected,
    onClick,
    resultsSummaryView,
}: {
    isSelected: boolean;
    onClick: () => void;
    resultsSummaryView: DexResultsSummaryView;
}) {
    return (
        <DexResultMenuListItem
            data-summary-id={resultsSummaryView.outgoingMessageId}
            tabIndex={-1}
            onClick={onClick}
            $isSelected={isSelected}
            $isHit={resultsSummaryView.isHit}
            leadingVisual={
                <UnreadIndicator
                    isRead={resultsSummaryView.isRead}
                    isHit={resultsSummaryView.isHit}
                />
            }
            trailingVisual={
                <DexResultItemTrailingVisual
                    dexResultsSummary={resultsSummaryView}
                    isSelected={isSelected}
                />
            }
        >
            <Text color="inherit">Summary</Text>
        </DexResultMenuListItem>
    );
}
